/* eslint-disable react/prop-types */
/* eslint-disable one-var */
/* eslint-disable no-prototype-builtins */
import React, {
    useState,
    useEffect,
    useContext,
    useImperativeHandle,
    forwardRef,
} from 'react';
// import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
    get as _get,
    has as _has,
} from 'lodash';

import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import {
    DataGridPro,
    useGridApiRef,
} from '@mui/x-data-grid-pro';

import DeleteIcon from '@mui/icons-material/Delete';
import MenuIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';

import {
    ColumnGroupName,
    ColumnGroupEnabled,
    ColumnGroupTotal,
    ColumnGroupEnable,
} from './columns';

import ConfirmationDialog from '../../../../components/confirmationdlg';
import { LoadingOverlay, NoRowsOverlay } from '../../../../components/xgrid/overlays';

import { ProfileContext } from '../../../../data/auth-service';
import SuricataService from '../../../../data/suricata-service';

import useWindowSize from '../../../../libraries/usewindowsize';

const useStyles = makeStyles(theme => ({
    root: {
        '& .columnHeader': {
            padding: '0 0 0 5px',
            height: 20,
            lineHeight: 20,
        },
    },
    suriSearch: {
        '& .MuiOutlinedInput-root': {
            borderTopRightRadius: '0px',
            borderBottomRightRadius: '0px',
        },
        '& input': {
            padding: '10px 14px',
        },
    },
    regexButton: {
        padding: '0px',
        minWidth: '30px',
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
    },
    filterButtons: {
        '& button': {
            padding: '2px 2px',
            fontSize: '11px',
        }
    },
    tooltipColor: {
        color: theme.palette.primary.contrastText,
    },
}));

const Groups = forwardRef(({
    groups,
    getGroups,
    col,
    groupSearch,
    updateGroupSearch,
    updater,
    updateUpdater,
    readonly,
    updateMod,
    otherGroupPolicies,
    selectedGroup,
    updateSelected,
    updatePrev,
    revert,
    managed,
    loading,
    updateSearchContext,
}, ref) => {
    const classes = useStyles();
    // const location = useLocation();
    const [columns, setColumns] = useState([]);
    const [, setColumnWidth] = useState({});
    const [groupMenuAnchor, setGroupMenuAnchor] = useState(null);
    const [deleteGroupDialog, setDeleteGroupDialog] = useState(false);
    const [selected, setSelected] = useState('');
    const { updateProfile, getProfile } = useContext(ProfileContext);
    const { height } = useWindowSize();
    const groupsRef = useGridApiRef();

    useImperativeHandle(ref, () => ({
        updateSelection: (selection) => {
            groupsRef.current.setSelectionModel([selection.name]);
        },
    }));

    useEffect(() => {
        setColumnWidth(getProfile('suricata').groupWidths || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setColumns(generateColumns());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groups]);

    useEffect(() => {
        updatePrev(selectedGroup);
        updateSelected(selected || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    useEffect(() => {
        if (revert) {
            setColumns(generateColumns({ actions: {}, source: 'ui', stack: [] }));
            if (groupsRef && groupsRef.current) {
                // Actual solution from MUI github issues with broken references, sync with timeout...
                setTimeout(() => {
                    groupsRef.current.scroll({ top: 0 });
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [revert]);

    // const readRouteQuery = () => {
    //     const routeQuery = new URLSearchParams(location.search);
    //     if (routeQuery.toString().length < 1) return {};
    //     return {
    //         group: routeQuery.has('group') ? routeQuery.get('group') : undefined,
    //         search: routeQuery.has('search') ? routeQuery.get('search') : undefined,
    //     };
    // };

    const generateColumns = (updatedMod) => {
        const p = getProfile('suricata');
        let c = [
            {
                headerClassName: 'columnHeader',
                sortable: true,
                width: _get(p, 'groupWidths.Name', 0),
                ...(_get(p, 'groupWidths.Name', 0) ? {} : { flex: 1 }),
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Name',
                field: 'name',
                renderCell: d => (
                    <ColumnGroupName d={d} search={groupSearch?.search} />
                ),
            },
            {
                headerClassName: 'columnHeader',
                sortable: true,
                width: _get(p, 'groupWidths.Enabled', 0),
                ...(_get(p, 'groupWidths.Enabled', 0) ? {} : { flex: 1 }),
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Enabled',
                field: 'enabled_rules',
                renderCell: d => (
                    <ColumnGroupEnabled
                        d={d}
                        updater={updater}
                    />
                ),
            },
            {
                headerClassName: 'columnHeader',
                sortable: true,
                width: _get(p, 'groupWidths.Total', 0),
                ...(_get(p, 'groupWidths.Total', 0) ? {} : { flex: 1 }),
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Total',
                field: 'total_rules',
                renderCell: d => (
                    <ColumnGroupTotal d={d} />
                ),
            },
            {
                headerClassName: 'columnHeader',
                sortable: true,
                width: _get(p, 'groupWidths.Enable', 0),
                ...(_get(p, 'groupWidths.Enable', 0) ? {} : { flex: 0.8 }),
                type: 'string',
                disableColumnMenu: true,
                hidden: false,
                headerName: 'Enable',
                field: 'enabled',
                renderCell: d => (
                    <ColumnGroupEnable
                        d={d}
                        updater={updater}
                        readonly={readonly}
                        handleGroupEnable={handleGroupEnable}
                    />
                ),
            },
        ];

        if (p.groupColumns && p.groupColumns.length) {
            c = p.groupColumns.map(v => {
                for (let i = c.length; i--;) {
                    if (v === c[i].headerName) {
                        return c[i];
                    }
                }
                return v;
            });
        }

        return c;
    };

    const handleColumnResize = () => {
        const widths = groupsRef.current.getAllColumns().reduce((a, c) => {
            a[c.headerName] = c.width;
            return a;
        }, {});
        updateProfile('suricata', {
            ...getProfile('suricata'),
            groupWidths: widths,
        });
        setColumnWidth(widths);
    };

    const handleColumnReorder = () => {
        let order = [];
        setTimeout(() => {
            order = groupsRef.current.getAllColumns().reduce((a, c) => {
                a.push(c.headerName);
                return a;
            }, []);

            updateProfile('suricata', {
                ...getProfile('suricata'),
                groupColumns: order,
            });
        });
    };

    const handleGroupSelection = (row, dataGrid) => {
        if (row.length) {
            const d = dataGrid.api.getRow(row);
            if (d) {
                if (selected === d.name) {
                    setSelected('');
                    dataGrid.api.setSelectionModel([]);
                } else {
                    setSelected(d.name);
                }
            }
        }
    };

    const handleGroupMenuOpen = (e) => {
        setGroupMenuAnchor(e.currentTarget);
    };

    const handleGroupMenuClose = () => {
        setGroupMenuAnchor(null);
    };

    const handleGroupEnable = (e, d) => {
        e.preventDefault();
        e.stopPropagation();

        const u = { ...updater };

        if (_has(u.groups, d.row.name)) {
            u.groups[d.row.name].enabled = e.target.checked;
        } else {
            u.groups[d.row.name] = {
                enabled: e.target.checked,
            };
        }

        updateUpdater(u);
    };

    const handleGroupSearch = (e) => {
        e.persist();
        updateGroupSearch({
            ...groupSearch,
            search: e.target.value,
            page: 0,
        });
    };

    const handleGroupRegex = () => {
        updateGroupSearch({
            ...groupSearch,
            exact: !groupSearch?.exact,
        });
    };

    const handleUpdateGroupEnableFilter = (v) => {
        const g = { ...groupSearch };
        if (v === 'enabled') {
            g.enabled = true;
        } else if (v === 'disabled') {
            g.enabled = false;
        } else {
            delete g.enabled;
        }
        g.page = 0;

        updateGroupSearch(g);
    };

    const handleEnableDisableAllGroups = (status) => {
        const u = { ...updater };
        u.modifier_group = {
            enabled: status,
        };
        setTimeout(() => {
            updateSearchContext('groups');
            updateUpdater(u);
        });
        handleGroupMenuClose();
    };

    const handleRowsScrollEnd = (e) => {
        if (groups && groups.groups.length && !(groups.groups % groupSearch.limit)) {
            updateGroupSearch({
                ...groupSearch,
                page: (groupSearch.page || 0) + 1,
            });
        }
    };

    const getGroupSortModel = () => {
        const ss = (groupSearch.sort || 'name asc').split(' ');
        return [{ field: ss[0], sort: ss[1] }];
    };

    const handleOnGroupSort = s => {
        if (!s.length) {
            s = [{ field: 'name', sort: 'asc' }];
        }
        updateGroupSearch({
            ...groupSearch,
            sort: `${s[0].field} ${s[0].sort}`,
            page: 0,
            limit: 50,
        });
    };

    const handleDeleteGroup = () => {
        const groups = [...groupsRef.current.getSelectedRows().values()];
        if (!groups.length) {
            return;
        }

        SuricataService.deleteGroup(groups[0].name).then(() => {
            updateGroupSearch({
                ...groupSearch,
                page: 0,
            });
            setSelected('');
            toast.success('Suricata group deleted successfully');
            setDeleteGroupDialog(false);
        }, err => {
            console.error(err);
            toast.error('Failed to delete Suricata group...');
            setDeleteGroupDialog(false);
        });
    };

    const handleDeleteGroupDialog = () => {
        setDeleteGroupDialog(!deleteGroupDialog);
    };

    const handleClearSearch = () => {
        setSelected('');
        groupsRef.current.setSelectionModel([]);
        updateGroupSearch({
            ...groupSearch,
            search: '',
            page: 0,
        });
    };

    return (
        <Grid item xs={col}>
            <Paper elevation={3}>
                <Box p={2}>
                    <Box mb={1} display="flex" justifyContent="space-between">
                        <Typography variant="h6">Groups</Typography>
                        <Box display="flex" justifyContent="flex-start" className={classes.headerBorder}>
                            <ButtonGroup className={classes.filterButtons}>
                                <Button
                                    color="secondary"
                                    variant={!groupSearch.hasOwnProperty('enabled') ? 'contained' : 'outlined'}
                                    aria-label="all groups"
                                    onClick={() => { handleUpdateGroupEnableFilter('all') }}
                                >All</Button>
                                <Button
                                    color="secondary"
                                    variant={groupSearch.enabled ? 'contained' : 'outlined'}
                                    aria-label="enabled groups"
                                    onClick={() => { handleUpdateGroupEnableFilter('enabled') }}
                                >Enabled</Button>
                                <Button
                                    color="secondary"
                                    variant={(groupSearch.hasOwnProperty('enabled') && !groupSearch.enabled) ? 'contained' : 'outlined'}
                                    aria-label="disabled groups"
                                    onClick={() => { handleUpdateGroupEnableFilter('disabled') }}
                                >Disabled</Button>
                            </ButtonGroup>
                            {!readonly && <Box display="flex" justifyContent="flex-end">
                                {managed
                                    ? <Tooltip title="Groups must be managed by the MC2.">
                                        <span>
                                            <IconButton disabled size="small" aria-label="delete group"><DeleteIcon /></IconButton>
                                        </span>
                                    </Tooltip>
                                    : <IconButton size="small" aria-label="delete group" onClick={handleDeleteGroupDialog}><DeleteIcon /></IconButton>
                                }
                                <IconButton size="small" aria-label="group menu" onClick={handleGroupMenuOpen}><MenuIcon /></IconButton>
                                <Menu anchorEl={groupMenuAnchor} open={Boolean(groupMenuAnchor)} onClose={handleGroupMenuClose}>
                                    <MenuItem onClick={() => { handleEnableDisableAllGroups(true) }}>Enable All</MenuItem>
                                    <MenuItem onClick={() => { handleEnableDisableAllGroups(false) }}>Disable All</MenuItem>
                                </Menu>
                            </Box>}
                        </Box>
                    </Box>
                    <Box display="flex" mb={1}>
                        <TextField
                            className={classes.suriSearch}
                            fullWidth
                            variant="outlined"
                            placeholder="Search groups"
                            // value={groupSearch?.group_search || ''}
                            value={groupSearch?.search || ''}
                            onChange={handleGroupSearch}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <Tooltip title="Clear search" classes={{ tooltip: classes.tooltipColor }}>
                                            <IconButton size="small" onClick={handleClearSearch}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Tooltip title="Regular expression search" classes={{ tooltip: classes.tooltipColor }}><Button className={classes.regexButton} variant={!groupSearch?.exact ? 'contained' : 'outlined'} aria-label="regex search" color="primary" onClick={handleGroupRegex}>.*</Button></Tooltip>
                    </Box>
                    <Box className={classes.root} height={height - 350}>
                        <DataGridPro
                            apiRef={groupsRef}
                            columns={columns}
                            rows={groups.groups}
                            getRowId={row => row?.name}
                            onSelectionModelChange={handleGroupSelection}
                            sortingOrder={['desc', 'asc']}
                            onRowsScrollEnd={handleRowsScrollEnd}
                            onSortModelChange={handleOnGroupSort}
                            sortModel={getGroupSortModel()}
                            onColumnResizeCommitted={handleColumnResize}
                            onColumnOrderChange={handleColumnReorder}
                            disableMultipleColumnsFiltering
                            disableMultipleColumnsSorting
                            disableMultipleSelection
                            components={{
                                Footer: () => (<div></div>),
                                LoadingOverlay: LoadingOverlay,
                                NoRowsOverlay: NoRowsOverlay,
                            }}
                            loading={loading && !groups?.groups.length}
                            loadingOverlay={(<div>Uh oh</div>)}
                        />
                    </Box>
                </Box>
            </Paper>
            <ConfirmationDialog
                onClose={handleDeleteGroupDialog}
                onOK={handleDeleteGroup}
                open={deleteGroupDialog}
                message={(() => {
                    let groupName = '';
                    if (groupsRef.current && groupsRef.current.getSelectedRows) {
                        if (groupsRef.current.getSelectedRows().size) {
                            if ([...groupsRef.current.getSelectedRows().values()][0]) {
                                groupName = [...groupsRef.current.getSelectedRows().values()][0].name;
                            }
                        }
                    }
                    return (
                        <React.Fragment>
                            <Typography>
                                Are you sure you would like to delete the group
                            </Typography>
                            <Box mt={1} ml={2}>
                                <Typography color="secondary">{groupName}</Typography>
                            </Box>
                            <Box mt={2} display={otherGroupPolicies && otherGroupPolicies.length ? 'none' : 'block'}>
                                <Typography>This group is not in use by any other policy.</Typography>
                            </Box>
                            <Box mt={2} display={otherGroupPolicies && otherGroupPolicies.length ? 'block' : 'none'}>
                                <Typography>This group is used in:</Typography>
                            </Box>
                            <Box mt={1} ml={2}>
                                {otherGroupPolicies && otherGroupPolicies.map((v, i) => {
                                    return (
                                        <Typography key={'other-group-policy-' + i} color="secondary">{v}</Typography>
                                    );
                                })}
                            </Box>
                        </React.Fragment>
                    );
                })()}
                title="Delete Group"
                cancelLabel="Cancel"
                okLabel="Yes"
            />
        </Grid>
    );
});

export default Groups;
